import {
  FETCH_CONDITION_SUMMARY_FAILURE,
  FETCH_CONDITION_SUMMARY_REQUEST,
  FETCH_CONDITION_SUMMARY_SUCCESS,
  FETCH_ITEM_ANALYSIS_SUMMARY_FAILURE,
  FETCH_ITEM_ANALYSIS_SUMMARY_REQUEST,
  FETCH_ITEM_ANALYSIS_SUMMARY_SUCCESS,
  FETCH_ITEM_SUMMARY_FAILURE,
  FETCH_ITEM_SUMMARY_REQUEST,
  FETCH_ITEM_SUMMARY_SUCCESS,
  FETCH_MOVEMENT_SUMMARY_FAILURE,
  FETCH_MOVEMENT_SUMMARY_REQUEST,
  FETCH_MOVEMENT_SUMMARY_SUCCESS,
  FETCH_TREATMENT_SUMMARY_FAILURE,
  FETCH_TREATMENT_SUMMARY_REQUEST,
  FETCH_TREATMENT_SUMMARY_SUCCESS,
  FETCH_VISIT_SUMMARY_FAILURE,
  FETCH_VISIT_SUMMARY_REQUEST,
  FETCH_VISIT_SUMMARY_SUCCESS,
} from './types';

const INITIAL_STATE = {
  itemSummary: null,
  itemSummaryError: null,
  itemSummaryLoading: false,

  treatmentSummary: null,
  treatmentSummaryError: null,
  treatmentSummaryLoading: false,

  movementSummary: null,
  movementSummaryError: null,
  movementSummaryLoading: false,

  conditionSummary: null,
  conditionSummaryError: null,
  conditionSummaryLoading: false,

  visitSummary: null,
  visitSummaryError: null,
  visitSummaryLoading: false,

  itemAnalysisSummary: null,
  itemAnalysisSummaryError: null,
  itemAnalysisSummaryLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // item
    case FETCH_ITEM_SUMMARY_REQUEST:
      return {
        ...state,
        itemSummaryLoading: true,
        itemSummaryError: null,
      };

    case FETCH_ITEM_SUMMARY_SUCCESS:
      return {
        ...state,
        itemSummaryLoading: false,
        itemSummary: action.payload,
      };

    case FETCH_ITEM_SUMMARY_FAILURE:
      return {
        ...state,
        itemSummaryLoading: false,
        itemSummaryError: action.payload.error,
        itemSummary: null,
      };
    // treatment
    case FETCH_TREATMENT_SUMMARY_REQUEST:
      return {
        ...state,
        treatmentSummaryLoading: true,
        treatmentSummaryError: null,
      };

    case FETCH_TREATMENT_SUMMARY_SUCCESS:
      return {
        ...state,
        treatmentSummaryLoading: false,
        treatmentSummary: action.payload,
      };

    case FETCH_TREATMENT_SUMMARY_FAILURE:
      return {
        ...state,
        treatmentSummaryLoading: false,
        treatmentSummaryError: action.payload.error,
        treatmentSummary: null,
      };

    // movement
    case FETCH_MOVEMENT_SUMMARY_REQUEST:
      return {
        ...state,
        movementSummaryLoading: true,
        movementSummaryError: null,
      };

    case FETCH_MOVEMENT_SUMMARY_SUCCESS:
      return {
        ...state,
        movementSummaryLoading: false,
        movementSummary: action.payload,
      };

    case FETCH_MOVEMENT_SUMMARY_FAILURE:
      return {
        ...state,
        movementSummaryLoading: false,
        movementSummaryError: action.payload.error,
        movementSummary: null,
      };

    // condition
    case FETCH_CONDITION_SUMMARY_REQUEST:
      return {
        ...state,
        conditionSummaryLoading: true,
        conditionSummaryError: null,
      };

    case FETCH_CONDITION_SUMMARY_SUCCESS:
      return {
        ...state,
        conditionSummaryLoading: false,
        conditionSummary: action.payload,
      };

    case FETCH_CONDITION_SUMMARY_FAILURE:
      return {
        ...state,
        conditionSummaryLoading: false,
        conditionSummaryError: action.payload.error,
        conditionSummary: null,
      };

    // visit
    case FETCH_VISIT_SUMMARY_REQUEST:
      return {
        ...state,
        visitSummaryLoading: true,
        visitSummaryError: null,
      };

    case FETCH_VISIT_SUMMARY_SUCCESS:
      return {
        ...state,
        visitSummaryLoading: false,
        visitSummary: action.payload,
      };

    case FETCH_VISIT_SUMMARY_FAILURE:
      return {
        ...state,
        visitSummaryLoading: false,
        visitSummaryError: action.payload.error,
        visitSummary: null,
      };

    // item analysis
    case FETCH_ITEM_ANALYSIS_SUMMARY_REQUEST:
      return {
        ...state,
        itemAnalysisSummaryLoading: true,
        itemAnalysisSummaryError: null,
      };

    case FETCH_ITEM_ANALYSIS_SUMMARY_SUCCESS:
      return {
        ...state,
        itemAnalysisSummaryLoading: false,
        itemAnalysisSummary: action.payload,
      };

    case FETCH_ITEM_ANALYSIS_SUMMARY_FAILURE:
      return {
        ...state,
        itemAnalysisSummaryLoading: false,
        itemAnalysisSummaryError: action.payload.error,
        itemAnalysisSummary: null,
      };

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
